<!-- Imagen header -->
    <div class="imagen-header">
        <!-- Imagen placeholder gris como en contacto.html -->
    </div>

    <!-- Contenido de la política -->
    <main class="contenido-politica">
        <div class="contenedor">
            <h1>Política de privacidad y uso de datos personales</h1>
            
            <section class="seccion-politica">
                <h2>1. PRESENTACIÓN</h2>
                <p>En Corporación Rehobot Contratistas Generales S.A.C, con RUC 20538054988 (en adelante, "Corporación Rehobot"), nos comprometemos a proteger la información personal de todos los que interactúan con nosotros a través de nuestro sitio web oficial: www.corporacionrehobot.com, así como por otros canales digitales o físicos relacionados a nuestros proyectos o procesos de selección de personal.</p>
                
                <p>La presente política tiene como finalidad explicar de manera clara cómo tratamos los datos personales que recopilamos, para qué los usamos y cuáles son tus derechos como titular de dicha información.</p>
            </section>

            <section class="seccion-politica">
                <h2>2. DATOS RECOPILADOS</h2>
                <p>Los datos que recopilamos pueden incluir, según el canal de contacto y el propósito:</p>
                <ul>
                    <li>Nombres y apellidos</li>
                    <li>Documento de identidad</li>
                    <li>Teléfono y correo electrónico</li>
                    <li>Profesión, especialidad, CV u hoja de vida (en procesos de postulación)</li>
                    <li>Información técnica o de proyectos si haces una consulta comercial</li>
                    <li>Cookies de terceros</li>
                </ul>
            </section>

            <section class="seccion-politica">
                <h2>3. RECOPILACIÓN DE DATOS PERSONALES</h2>
                <p>Recolectamos tus datos personales cuando:</p>
                <ul>
                    <li>Nos escribes mediante el formulario de contacto en la web</li>
                    <li>Postulas a través de la sección "Trabaja con nosotros" o por correo</li>
                    <li>Te comunicas con nosotros por redes sociales, correo o llamada</li>
                </ul>
                
                <p>En todos los casos, el envío de datos es voluntario y el usuario puede optar por no proporcionarlos. Sin embargo, su omisión puede impedir una correcta atención a sus solicitudes.</p>
            </section>

            <section class="seccion-politica">
                <h2>4. USO DE DATOS</h2>
                <p>Los datos que recopilamos son utilizados exclusivamente para las siguientes finalidades:</p>
                <ul>
                    <li>Atender consultas técnicas o comerciales sobre nuestros servicios</li>
                    <li>Brindar información solicitada sobre proyectos o cotizaciones</li>
                    <li>Gestionar procesos de selección y mantener una base de talentos</li>
                    <li>Mejorar la experiencia de navegación en nuestro sitio web</li>
                    <li>Elaborar estadísticas internas sobre el uso del sitio</li>
                </ul>
                
                <p>No realizamos perfiles automatizados ni enviamos publicidad masiva sin consentimiento previo.</p>
            </section>

            <section class="seccion-politica">
                <h2>5. TRANSFERENCIA DE DATOS PERSONALES</h2>
                <p>Corporación Rehobot no vende, cede ni transfiere tus datos personales a terceros.</p>
                <p>Solo podríamos compartir información en los siguientes casos:</p>
                <ul>
                    <li>Si es requerido por autoridades administrativas o judiciales, conforme a ley</li>
                    <li>Si contratamos proveedores de servicios que nos apoyen en la gestión de la página o reclutamiento, bajo acuerdos de confidencialidad</li>
                    <li>Si el usuario lo autoriza expresamente</li>
                </ul>
            </section>

            <section class="seccion-politica">
                <h2>6. SEGURIDAD</h2>
                <p>Adoptamos medidas técnicas y organizativas razonables para proteger tus datos personales contra pérdida, acceso no autorizado, alteración o uso indebido. No obstante, como todo entorno digital, existen riesgos inherentes al uso de Internet.</p>
            </section>

            <section class="seccion-politica">
                <h2>7. DERECHOS</h2>
                <p>Tienes derecho a solicitar en cualquier momento:</p>
                <ul>
                    <li>Acceso a tus datos personales</li>
                    <li>Rectificación o actualización</li>
                    <li>Eliminación o supresión</li>
                    <li>Oposición al uso de tus datos</li>
                    <li>Revocación del consentimiento otorgado</li>
                </ul>
                
                <p>Para ejercer estos derechos, escríbenos a: info@corporacionrehobot.com</p>
            </section>

            <section class="seccion-politica">
                <h2>8. MENORES DE EDAD</h2>
                <p>Nuestro sitio web y servicios no están dirigidos a menores de 18 años. No recopilamos intencionalmente datos de menores. Si detectamos que se han recibido, procederemos a eliminarlos de inmediato.</p>
            </section>

            <section class="seccion-politica">
                <h2>9. CONSENTIMIENTO</h2>
                <p>Al interactuar con nosotros o enviar tus datos por cualquier medio, declaras haber leído y aceptado esta política, autorizando el tratamiento de tu información conforme a lo aquí establecido.</p>
            </section>

            <section class="seccion-politica">
                <h2>10. VIGENCIA Y MODIFICACIONES</h2>
                <p>Esta política fue actualizada el 2 de agosto de 2025.</p>
                <p>Corporación Rehobot se reserva el derecho de modificarla en cualquier momento. Toda nueva versión será publicada en el sitio web y se considerará vigente desde su publicación.</p>
            </section>
        </div>
    </main>